import React from 'react';
import { TTextTranslationNamespaces } from 'types';
import { Modal } from 'antd';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './ModalContent.module.scss';

interface IProps {
	onConsentEvent: () => void;
	onFailureEvent: () => void;
	onCloseModal?: () => void;
	heading: string;
	headingAlignment?: 'left' | 'center' | 'right';
	headerTranslationNameSpace?: TTextTranslationNamespaces;
	translationOfConfirmBtn?: string;
	centered?: boolean;
	width?: string;
	isDisabledSave?: boolean;
}

export const ModalContent: React.FC<IProps> = ({
	onConsentEvent,
	onFailureEvent,
	onCloseModal,
	heading,
	headingAlignment = 'center',
	children,
	headerTranslationNameSpace = 'form',
	translationOfConfirmBtn = 'confirmButton',
	centered = true,
	width = '44%',
	isDisabledSave = false,
}) => {
	return (
		<Modal
			bodyStyle={{ padding: '24px 0 0 0' }}
			className={style.modalContainer}
			visible={true}
			onCancel={onCloseModal ? onCloseModal : onFailureEvent}
			width={width}
			closeIcon={
				<svg className={style.closeIcon}>
					<use xlinkHref={`${breadcrumbs}#crossMark`} />
				</svg>
			}
			centered={centered}
			destroyOnClose={true}
			footer={null}
			data-test="ModalContent">
			<div className={style.container}>
				<Text
					className={style.modalHeader}
					translationNameSpace={headerTranslationNameSpace}
					translationKey={heading}
					size="xxl"
					weight="bold"
					align={headingAlignment}
				/>
				{children}
				<div className={style.btnWrapper}>
					<Button theme="secondary" onClick={onFailureEvent} data-test="cancelButton">
						<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
					</Button>
					<Button
						theme="primaryBlue"
						onClick={onConsentEvent}
						disabled={isDisabledSave}
						data-test="confirmButton">
						<Text translationNameSpace="form" translationKey={translationOfConfirmBtn} asFragment={true} />
					</Button>
				</div>
			</div>
		</Modal>
	);
};
